// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HistorialMedico.module.css */

.HistorialMedico_subtitle__3JIQC {
  font-size: 14px;
  color: #667085;
  margin-bottom: 20px;
  margin-top: -12px;
}

.HistorialMedico_searchInput__yXfdS {
  width: 100%;
  height: 40px;
  padding: 0 14px;
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  font-size: 14px;
  color: #344054;
  outline: none;
  box-sizing: border-box;
  font-family: inherit;
}

.HistorialMedico_searchInput__yXfdS:focus {
  border-color: #1a3a5c;
}
.HistorialMedico_searchInput__yXfdS::placeholder {
  color: #b0b8c4;
}

.HistorialMedico_twoCol__ICXXu {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 16px;
  align-items: start;
}

/* Fila historial */
.HistorialMedico_histRow__nHEwA {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 10px;
  border-radius: 10px;
  cursor: pointer;
  border: 1.5px solid transparent;
  transition:
    background 0.15s,
    border-color 0.15s;
  margin-bottom: 4px;
}

.HistorialMedico_histRow__nHEwA:hover {
  background: #f8fafc;
}
.HistorialMedico_histRowActive__ChVXp {
  background: #f0fdf9;
  border-color: #2db899;
}

.HistorialMedico_histLeft__6r3VV {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.HistorialMedico_histAvatar__OcxdC {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #e6f7f3;
  color: #2db899;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.HistorialMedico_histSpec__cjaNA {
  font-size: 14px;
  font-weight: 700;
  color: #344054;
  margin-bottom: 2px;
}
.HistorialMedico_histDoc__PK1LB {
  font-size: 12px;
  color: #667085;
  margin-bottom: 3px;
}
.HistorialMedico_histDate__6LUw- {
  font-size: 12px;
  color: #98a2b3;
}

.HistorialMedico_histMeta__N\\+rz8 {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
}

/* Detalle */
.HistorialMedico_detail__tJHZS {
  display: flex;
  flex-direction: column;
}

.HistorialMedico_detailHeader__8QjRM {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f2f4f7;
}

.HistorialMedico_detailAvatar__Z9cu8 {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #1a3a5c;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.HistorialMedico_detailSpec__CTHLz {
  font-size: 15px;
  font-weight: 700;
  color: #1a3a5c;
  margin-bottom: 3px;
}
.HistorialMedico_detailDoc__pVCiB {
  font-size: 13px;
  color: #667085;
}

.HistorialMedico_detailRow__ojkm7 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f2f4f7;
  font-size: 13px;
}

.HistorialMedico_detailRow__ojkm7 span {
  color: #98a2b3;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.HistorialMedico_detailRow__ojkm7 strong {
  color: #344054;
  font-weight: 600;
}

.HistorialMedico_detailSection__6yGst {
  margin-top: 16px;
}
.HistorialMedico_detailSectionTitle__Yh4y0 {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #98a2b3;
  margin-bottom: 6px;
}
.HistorialMedico_detailSectionText__Vp-ab {
  font-size: 13px;
  color: #344054;
  line-height: 1.6;
  background: #f8fafc;
  border-radius: 8px;
  padding: 10px 12px;
}

@media (max-width: 860px) {
  .HistorialMedico_twoCol__ICXXu {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HistorialMedico/HistorialMedico.module.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B;;sBAEoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* HistorialMedico.module.css */\n\n.subtitle {\n  font-size: 14px;\n  color: #667085;\n  margin-bottom: 20px;\n  margin-top: -12px;\n}\n\n.searchInput {\n  width: 100%;\n  height: 40px;\n  padding: 0 14px;\n  border: 1.5px solid #d0d5dd;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #344054;\n  outline: none;\n  box-sizing: border-box;\n  font-family: inherit;\n}\n\n.searchInput:focus {\n  border-color: #1a3a5c;\n}\n.searchInput::placeholder {\n  color: #b0b8c4;\n}\n\n.twoCol {\n  display: grid;\n  grid-template-columns: 1fr 300px;\n  gap: 16px;\n  align-items: start;\n}\n\n/* Fila historial */\n.histRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 10px;\n  border-radius: 10px;\n  cursor: pointer;\n  border: 1.5px solid transparent;\n  transition:\n    background 0.15s,\n    border-color 0.15s;\n  margin-bottom: 4px;\n}\n\n.histRow:hover {\n  background: #f8fafc;\n}\n.histRowActive {\n  background: #f0fdf9;\n  border-color: #2db899;\n}\n\n.histLeft {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.histAvatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #e6f7f3;\n  color: #2db899;\n  font-size: 12px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.histSpec {\n  font-size: 14px;\n  font-weight: 700;\n  color: #344054;\n  margin-bottom: 2px;\n}\n.histDoc {\n  font-size: 12px;\n  color: #667085;\n  margin-bottom: 3px;\n}\n.histDate {\n  font-size: 12px;\n  color: #98a2b3;\n}\n\n.histMeta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 5px;\n}\n\n/* Detalle */\n.detail {\n  display: flex;\n  flex-direction: column;\n}\n\n.detailHeader {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #f2f4f7;\n}\n\n.detailAvatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: #1a3a5c;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.detailSpec {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a3a5c;\n  margin-bottom: 3px;\n}\n.detailDoc {\n  font-size: 13px;\n  color: #667085;\n}\n\n.detailRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 0;\n  border-bottom: 1px solid #f2f4f7;\n  font-size: 13px;\n}\n\n.detailRow span {\n  color: #98a2b3;\n  font-weight: 600;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n.detailRow strong {\n  color: #344054;\n  font-weight: 600;\n}\n\n.detailSection {\n  margin-top: 16px;\n}\n.detailSectionTitle {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  color: #98a2b3;\n  margin-bottom: 6px;\n}\n.detailSectionText {\n  font-size: 13px;\n  color: #344054;\n  line-height: 1.6;\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 10px 12px;\n}\n\n@media (max-width: 860px) {\n  .twoCol {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subtitle": `HistorialMedico_subtitle__3JIQC`,
	"searchInput": `HistorialMedico_searchInput__yXfdS`,
	"twoCol": `HistorialMedico_twoCol__ICXXu`,
	"histRow": `HistorialMedico_histRow__nHEwA`,
	"histRowActive": `HistorialMedico_histRowActive__ChVXp`,
	"histLeft": `HistorialMedico_histLeft__6r3VV`,
	"histAvatar": `HistorialMedico_histAvatar__OcxdC`,
	"histSpec": `HistorialMedico_histSpec__cjaNA`,
	"histDoc": `HistorialMedico_histDoc__PK1LB`,
	"histDate": `HistorialMedico_histDate__6LUw-`,
	"histMeta": `HistorialMedico_histMeta__N+rz8`,
	"detail": `HistorialMedico_detail__tJHZS`,
	"detailHeader": `HistorialMedico_detailHeader__8QjRM`,
	"detailAvatar": `HistorialMedico_detailAvatar__Z9cu8`,
	"detailSpec": `HistorialMedico_detailSpec__CTHLz`,
	"detailDoc": `HistorialMedico_detailDoc__pVCiB`,
	"detailRow": `HistorialMedico_detailRow__ojkm7`,
	"detailSection": `HistorialMedico_detailSection__6yGst`,
	"detailSectionTitle": `HistorialMedico_detailSectionTitle__Yh4y0`,
	"detailSectionText": `HistorialMedico_detailSectionText__Vp-ab`
};
export default ___CSS_LOADER_EXPORT___;
